import React, { useState } from 'react';
import api from '../../lib/api';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';

export const UndoPayrollDialog = ({ run, open, onClose, onUndone }) => {
  const [text, setText] = useState('');
  const [busy, setBusy] = useState(false);
  const close = () => { setText(''); onClose(); };
  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/payroll/runs/${run.run_id}/undo`, { confirm: text });
      toast.success(`Payroll undone — ${data.overpayments_reverted} overpayment adjustment(s) returned to Pending`);
      setText('');
      onUndone(data);
    } catch (e) {
      const d = e?.response?.data?.detail;
      toast.error(typeof d === 'string' ? d : 'Undo failed');
    } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={o => { if (!o) close(); }}>
      <DialogContent data-testid="pr-undo-dialog">
        <DialogHeader>
          <DialogTitle>Undo payroll run?</DialogTitle>
          <DialogDescription>
            This deletes the draft run for <b>{run.period_start} → {run.period_end}</b>: every processed row,
            Gusto verification, session adjustment and summary entry is discarded, and all overpayment
            adjustments applied to this run go back to Pending. SP data is re-scanned so a fresh run re-flags everything.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          <label className="text-xs font-medium" htmlFor="pr-undo-input">Type <b>UNDO</b> to confirm</label>
          <Input id="pr-undo-input" value={text} onChange={e => setText(e.target.value)}
                 autoComplete="off" data-testid="pr-undo-confirm-input" />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={close} data-testid="pr-undo-cancel">Cancel</Button>
          <Button variant="destructive" disabled={text !== 'UNDO' || busy}
                  onClick={submit} data-testid="pr-undo-submit">
            {busy ? 'Undoing…' : 'Undo payroll'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
